import { Routes, Route } from 'react-router-dom';

import Landing from './screens/Landing/Landing';

function App() {
  return (
    <Routes>
      <Route path="/" element={<Landing />}></Route>
      <Route index element={<Landing />}></Route>
    </Routes>
  );
}
export default App;
